import { CommonMessages } from 'src/messages/validationMessages';
import { EMAIL_REGEX } from 'src/utils/constants';
import * as Yup from 'yup';

export const UnsubscribeSchema = Yup.object().shape({
    email: Yup.string()
        .matches(EMAIL_REGEX, CommonMessages.email_invalid)
        .required(CommonMessages.email_required),
});